import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { ChatCompletionsMessageObject } from "../../../services/api/instances/completionsApi/types";
import type {
  Model,
  ModelsValue,
} from "../../../services/api/instances/modelsApi/types";
import { createChatReducerBuilder } from "./reducers";
import type { ChatCompletionState } from "./types";

export const initialState: ChatCompletionState = {
  messages: [],
  isMessageLoading: false,
};

const chatCompletionSlice = createSlice({
  name: "chatCompletion",
  initialState,
  reducers: {
    setMessages: (
      state,
      action: PayloadAction<ChatCompletionsMessageObject[]>
    ) => {
      state.messages = action.payload;
    },
  },
  extraReducers: (builder) => {
    createChatReducerBuilder(builder);
  },
});

export const chatCompletionReducers = chatCompletionSlice.reducer;
export const { setMessages } = chatCompletionSlice.actions;
